import API from "../../../app/api";

export const getcategory = async () => {
  try {
    const res = await API.get("/products/agarthi-253");

    return res?.data?.success
      ? res.data?.data ?? []
      : [];
  } catch (error) {
    console.error("Category Error:", error);
    return [];
  }
};